import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Dropdown, Grid } from "semantic-ui-react";
import axios from "axios";
import _ from "lodash";
import settings, { getApiHost } from "../../../settings";
import InlineError from "../../messages/InlineError";
import { expireSession } from "../../../actions/auth";
import {
  ERR_MSG_SESSION_EXPIRED,
  ERR_SELECT_ITEM_IN_LIST,
} from "../../../ErrorMessages";
import { addItemToStates } from "../../../actions/statesList";

class StateControl extends Component {
  constructor(props) {
    super(props);
    this.formStateRef = React.createRef();
    this.state = {
      options: [],
      cancelTokenSource: undefined,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      if (nextProps.defaultData === "-1")
        setTimeout(() => {
          this.formStateRef.current.toggle();
        }, 100);
    }
    if (nextProps.defaultData !== undefined) {
      this.loadData(nextProps);
    }
  }

  componentWillUnmount() {
    this.isCompMounted = false;
    if (this.state.cancelTokenSource !== undefined) {
      this.state.cancelTokenSource.cancel("State unmounting...");
    }
  }

  setDefaultStateSelectedOption = (props, options) => {
    if (props.defaultData && props.defaultData !== "-1") {
      const option = _.find(options, (o) => o.value === props.defaultData);
      option.name = props.control.FieldName;
      if (option) this.handleStateSelect(this, option);
    } else {
      const selOption = options[0];
      selOption.name = props.control.FieldName;
      this.handleStateSelect(this, selOption);
    }
  };

  isCompMounted = false;

  loadData = (props) => {
    this.isCompMounted = true;
    const appStatesKey = `${props.control.FormId}_${
      props.reportId ? props.reportId : 0
    }`;
    if (
      props.appStates &&
      Object.keys(props.appStates).includes(appStatesKey)
    ) {
      const options = props.appStates[appStatesKey];
      if (this.isCompMounted) this.setState({ options });
      this.setDefaultStateSelectedOption(props, options);
      return;
    }
    const cancelTokenSource = axios.CancelToken.source();
    axios
      .post(
        `${getApiHost(settings.env)}/states.aspx`,
        {
          appName: settings.appName,
          ReportId: props.reportId,
          FormId: props.control.FormId,
        },
        { async: false }
      )
      .then((res) => {
        if (_.get(res, "errors.error.errType") === "unauthorized") {
          props.expireSession(ERR_MSG_SESSION_EXPIRED);
          return;
        }
        const options = [];
        options.push({
          key: "-1",
          value: "-1",
          text: props.control.FieldRequired
            ? "Select a State"
            : "All Available States",
        });
        _.map(res.data.Data, (state) => {
          options.push({
            key: state.StateCode,
            value: state.StateCode,
            text: state.StateDesc,
          });
        });
        props.addItemToStates({ stateKey: appStatesKey, states: options });
        if (this.isCompMounted)
          this.setState({ options, cancelTokenSource: undefined });
        this.setDefaultStateSelectedOption(props, options);
      })
      .catch((err) => {
        console.log("state cancel error", err);
        if (err.response && err.response.status === 401) {
          if (props && props.expireSession)
            props.expireSession(ERR_MSG_SESSION_EXPIRED);
          return;
        }
        if (this.isCompMounted) this.setState({ cancelTokenSource: undefined });
      });
    if (this.isCompMounted) this.setState({ cancelTokenSource });
  };

  handleStateSelect = (e, data) => {
    if (
      this.props.notifyChangeToForm !== undefined &&
      this.props.defaultData !== data.value
    ) {
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
    }
  };

  render() {
    const { control, isLeftSearch } = this.props;
    if (control === undefined) {
      return null;
    }
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`drop_${control.FieldId}`}>
        {control.controlLabel !== "" &&
          (this.props.hideLabel === undefined || !this.props.hideLabel) ? (
          <Grid.Column width={isLeftSearch ? 6 : 6}>
            <Form.Field>
              <label
                htmlFor={control.FieldLabel}
                style={{ color }}
                className="padding-5"
              >
                {control.FieldLabel}
              </label>
            </Form.Field>
          </Grid.Column>
        ) : null}
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field>
            <Dropdown
              fluid
              search
              selectOnBlur={false}
              key={`state_${control.FormId}_${control.FieldId}`}
              selection
              id={`state_${control.FormId}_${control.FieldId}`}
              options={this.state.options}
              name={control.FieldName}
              placeholder={control.controlPlaceholder}
              value={this.props.defaultData}
              label={control.FieldLabel}
              onChange={(e, data) => {
                this.handleStateSelect(e, data);
              }}
              style={{ color: { color } }}
              ref={this.formStateRef}
              size="small"
            />
          </Form.Field>
          {this.props.errors[control.FieldName] !== undefined &&
            this.props.errors[control.FieldName] !== "" && (
              <InlineError text={ERR_SELECT_ITEM_IN_LIST} />
            )}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    appStates:
      state.appStatesList && state.appStatesList.appStates
        ? state.appStatesList.appStates
        : undefined,
  };
}

export default connect(mapStateToProps, { expireSession, addItemToStates })(
  StateControl
);



// WEBPACK FOOTER //
// ./src/components/forms/controls/StateControl.js